import React from 'react'
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import LuggageTableHeader from './LuggageTableHeader'
import { sourceHeader } from './LuggageConstant'
import { navigation3 } from '../../../../common/helper'

const SourceTable = ({UseToPayAsCOD, filterData, tableData, setTableData, destTableData, setDestTableData }) => {
    
    const handleTableChecked = (event, index, field) => {
        setTableData([...tableData.map((val, i) => i === index ? { ...val, [field]: event.target.checked ? 1 : 0 } : val)])
        handleDestinationChecked(event.target.checked, field)
    }
    const handleDestinationChecked = (value, field) => {
        let newArr = destTableData.map((val) => ({
            ...val,
            DestinationData: val.DestinationData.map((val1) => ({ ...val1, [field]: value ? 1 : 0 })),
            [field]: value
        }))
        setDestTableData(newArr)
    }
    return (
        <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '50vh', marginTop: '12px', marginBottom: "18px" }} >
            <Table stickyHeader size="small" aria-label="a dense table" sx={{
                '& .MuiTableCell-root': {
                    padding: '6px 8px !important'
                }
            }}>
                <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                    <LuggageTableHeader columnDefs={sourceHeader} UseToPayAsCOD={UseToPayAsCOD}/>
                </TableHead>
                <TableBody>
                    <TableRow sx={{ backgroundColor: "#F5FAFE" }}>
                        <TableCell></TableCell>
                        <TableCell sx={{ minHeight: '36px', fontSize: '12px', color: '#444', fontWeight: '500', fontStyle: 'italic' }} colSpan={'11'} align={'left'}>{filterData?.sourceCity}</TableCell>
                    </TableRow>
                    {tableData.map((row, index) => {
                        return (
                            <TableRow key={`DR-${index}`}>
                                <TableCell></TableCell>
                                <TableCell sx={{ minHeight: '36px', fontSize: '12px', color: '#444', fontWeight: '500' }} align='left'>{filterData?.sourceBranch}</TableCell>
                                {sourceHeader.map((obj, index1) => {
                                    return (
                                        !(["", "Source"].includes(obj.field)) ?
                                            <TableCell key={`TCH-${index1}`
                                            } align='center' >
                                                <Checkbox
                                                    id={`${obj.field}-${index}`}
                                                    sx={{ padding: 0 }}
                                                    checked={row[obj.field] === 1}
                                                    onChange={(e) => { handleTableChecked(e, index, obj.field) }}
                                                    onKeyDown={(e) => {
                                                        navigation3(e, index1 === 11 && (tableData.length - 1) === index ? "searchContain" : `${obj.nextId}-${index}`, index1 === 2 ? 'activeBtn' : `${obj.prevId}-${index}`, () => { })
                                                    }}
                                                />
                                            </TableCell>
                                            : null
                                    )
                                })}
                               

                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer >
    )
}

export default SourceTable